/**
 * @desc 获取所有设备
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.EquipmentPageRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.QueryEquipmentResponse>>> {
  return defHttp.post({
    url: '/wap/equipment/list',
    data,
  });
}

export function mock(
  data: defs.EquipmentPageRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.QueryEquipmentResponse>>> {
  return defHttp.post({
    url: '/mock/wap/equipment/list',
    data,
  });
}
